import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom';
import Select from 'react-select';

import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
// import {adminMainUrl} from '../../../../Config'
// import AddMaster from "./AddMaster";
// import EditMaster from "./EditMaster";
// import { adminMainUrl } from '../../../../Config';
// import { DesignationApi } from '../../../../Redux/action/MasterAction';

const GeneralJobs = ({ accessedModules, accessedPermission }) => {
  
   
    const columns = [
        { title: "OL", dataIndex: "currencyName", key: "currencyName" },
        { title: "FL", dataIndex: "code", key: "code" },       
        { title: "Date", dataIndex: "effectiveDate", key: "effectiveDate" },
        { title: "Job Type", dataIndex: "validUpto", key: "validUpto" },
        { title: "Job No.", dataIndex: "forImport", key: "forImport" },
        { title: "Organization", dataIndex: "forImport", key: "forImport" },
        { title: "Location", dataIndex: "forImport", key: "forImport" },
        { title: "Status", dataIndex: "forImport", key: "forImport" },

    ];
    


    

    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                      General Jobs <span className="count-title">3</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="card">

                        <div className="card-body">

                            {/* Filter */}
                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-sort-ascending-2 me-2" />
                                            Sort{" "}
                                        </a>

                                        <div className="dropdown-menu  dropdown-menu-start">
                                            <ul>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Ascending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Descending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Viewed
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Added
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                    

                                    <div className="icon-form mb-3 mb-sm-0">
                                        <span className="form-icon">
                                            <i className="ti ti-search" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Search "
                                            name='search_by'
                                        // value={searchText}
                                        // onChange={(e) => setSearchText(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-sorts dropdown ms-2">
                                        <Tooltip placement="top" title="Filter">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="dropdown"
                                                data-bs-auto-close="outside"
                                                // className='py-1'
                                                style={{
                                                    paddingTop: "7px",
                                                    paddingBottom: "6px"
                                                }}
                                            >
                                                <i className="ti ti-filter-share me-0" />
                                                {/* Filter */}
                                            </a>
                                        </Tooltip>
                                        <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                                            <div className="filter-set-view">
                                                {/* <div className="filter-set-head">
                                                    <h4>
                                                        <i className="ti ti-filter-share" />
                                                        Filter
                                                    </h4>
                                                </div> */}
                                                <table className="content-table">
                                                <tbody>
                   
                      
                          <tr>
                              <td>
                                  <label htmlFor="consolno.">Period</label>
                              </td>
                              <td className="input_box_filter">
                                  <input
                                      type="date"
                                      className="form-control form-control-sm ms-2"
                                      placeholder=""
                                      name="consolno."
                                  />
                              </td>
                          </tr>
                          
                          <tr>
                              <td>
                                  <label htmlFor="consoleType">Active</label>
                              </td>
                              <td className="input_box_filter">
                                  <select
                                      className="form-control form-control-sm ms-2"
                                      id="consoleType"
                                  >
                                      <option value="ALL">Yes</option>
                                      <option value="1">No</option>
                                     
                                  </select>
                              </td>
                          </tr>
                            
                          <tr>
                              <td>
                                  <label htmlFor="consoleType">Job No.</label>
                              </td>
                              <td className="input_box_filter">
                              <Select className="custom-selector ms-2 w-100" name="" placeholder="" />

                              </td>
                          </tr>
                          
                          <tr>
                              <td>
                                  <label htmlFor="consoleType">Organisation</label>
                              </td>
                              <td className="input_box_filter">
                              <Select className="custom-selector ms-2 w-100" name="" placeholder="" />

                              </td>
                          </tr>
                          <tr>
                              <td>
                                  <label htmlFor="consoleType">Job Owner</label>
                              </td>
                              <td className="input_box_filter">
                              <Select className="custom-selector ms-2 w-100" name="" placeholder="" />

                              </td>
                          </tr>
                          <tr>
                              <td>
                                  <label htmlFor="consoleType">Job Type</label>
                              </td>
                              <td className="input_box_filter">
                              <Select className="custom-selector w-100 ms-2" name="" placeholder="" />
                              <input type="number" id="effectiveFrom" className="form-control form-control-sm ms-2 w-100"
                                  />
                              </td>
                          </tr>
                          <tr>
                              <td>
                                  <label htmlFor="consoleType">Location</label>
                              </td>
                              <td className="input_box_filter">
                              <Select className="custom-selector w-100 ms-2" name="" placeholder="Delhi" />

                              </td>
                          </tr>
                                                
                          
                       
                      </tbody>
                                                </table>
                                                <div className="filter-reset-btns">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <a className="btn btn-light">
                                                                Reset
                                                            </a>
                                                        </div>
                                                        <div className="col-6">
                                                            <button type='submit' className="btn btn-primary w-100">
                                                                Filter
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                   
                                    {/* <div className="icon-form">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control bookingrange"
                                            placeholder=""
                                        />
                                    </div> */}
                                </div>
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <Tooltip placement="top" title="Print Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="ti ti-printer text-white"></i>
                                            {/* <ReactTooltip id="print" place="top" effect="solid" /> */}
                                        </div>
                                    </Tooltip>
                                    <Tooltip placement="top" title="Import Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="fa fa-file-import text-white"></i>
                                            {/* <ReactTooltip id="print" place="top" effect="solid" /> */}
                                        </div>
                                    </Tooltip>
                                    <Tooltip placement="top" title="Export Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="fas fa-file-export text-white"></i>
                                            {/* <ReactTooltip id="export" place="top" effect="solid" /> */}
                                        </div>
                                    </Tooltip>
                                    <button type='submit' className="btn btn-primary me-2">
                                        Search
                                    </button>
                                    <a
                                        className='btn btn-light me-2'
                                    //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                                    >
                                        Clear
                                    </a>
                                    <a inert href='/flexichain/Billing/GeneralJobs/add'
                                        className='btn btn-primary cursor-pointer me-2'
                                    //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                                    >
                                        + Add
                                    </a>
                                    
                                    {/* <div
                                        className="btn btn-primary cursor-pointer me-2"
                                        // onClick={handleAddShow}
                                        onClick={() => { navigate("/flexichain/forwarding/international/land-export/HCNoteStock/add") }}
                                    >
                                        <i className="ti ti-square-rounded-plus me-2" />
                                        Add
                                    </div> */}

                                    {/* <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="btn bg-soft-purple text-purple"
                                            data-bs-toggle="dropdown"
                                            data-bs-auto-close="outside"
                                        >
                                            <i className="ti ti-columns-3 me-2" />
                                            Manage Columns
                                        </a>
                                        <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                                            <h4 className="mb-2 fw-semibold">Want to manage datatables?</h4>
                                            <p className="mb-3">
                                                Please drag and drop your column to reorder your table and
                                                enable see option as you want.
                                            </p>
                                            <div className="border-top pt-3">
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Name
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-name" className="check" />
                                                        <label htmlFor="col-name" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Phone
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-phone" className="check" />
                                                        <label htmlFor="col-phone" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Email
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-email" className="check" />
                                                        <label htmlFor="col-email" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Tags
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-tag" className="check" />
                                                        <label htmlFor="col-tag" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Location
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-loc" className="check" />
                                                        <label htmlFor="col-loc" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Rating
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-rate" className="check" />
                                                        <label htmlFor="col-rate" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Owner
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-owner" className="check" />
                                                        <label htmlFor="col-owner" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Contact
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-contact"
                                                            className="check"
                                                            defaultChecked=""
                                                        />
                                                        <label htmlFor="col-contact" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Status
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-status"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-status" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Action
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-action"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-action" className="checktoggle" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                    {/* <div className="view-icons">
                                        <Link onClick={() => { setGrid(true) }} className={`${grid === true && "active"}`}>
                                            <i className="ti ti-list-tree" />
                                        </Link>
                                        <Link onClick={() => { setGrid(false) }} className={`${grid === false && "active"}`}>
                                            <i className="ti ti-grid-dots" />
                                        </Link>
                                    </div> */}
                                </div>

                            </div>
                            {/* /Filter */}
                            
                            {/* Contact List */}

                            {/* {
                                loadingDesignationTypeApi ?
                                    arr.map((value, index) => {
                                        return (

                                            <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                            <BeatLoader />
                                        </div>
                                        )
                                    }) :
                                    spinnerLoader ?
                                        <>
                                            <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                                <BeatLoader />
                                            </div>
                                        </> :
                                        <> */}
                            <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                     columns={columns} />
                            </div>

                            {/* <Pagination data={currentItems} dataPerPage={dataPerPage} setDataOffset={setDataOffset} dataOffset={dataOffset} setPageCount={setPageCount} pageCount={pageCount} setCurrentData={setCurrentData} currentData={currentData} />
                                        </>
                            } */}
                            {/* <div className="pagination-controls my-5 d-flex justify-content-center align-items-center">
                                <button
                                    className=''
                                    onClick={() => handlePageChange(count - 1)}
                                    disabled={count === 1}
                                >
                                    <img src="/img/right.png" className='mx-2' alt="right" />
                                </button>

                                {pageNumbers.map((number, index) =>
                                    number === '...' ? (
                                        <span key={index} className="mx-2">...</span>
                                    ) : (
                                        <span
                                            key={number}
                                            className={`search-btn-1 ${number === count ? 'active' : ''}`}
                                            onClick={() => handlePageChange(number)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {number}
                                        </span>
                                    )
                                )}

                                <button
                                    onClick={() => handlePageChange(count + 1)}
                                    disabled={count === totalPages}
                                >
                                    <img src="/img/left.png" className='mx-2' alt="right" />
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* <AddMaster show={addShow} handleClose={handleAddClose} onSuccess={handleSuccess} />
            <EditMaster show={editshow} handleClose={handleEditClose} onSuccess={handleSuccess} /> */}
            {/* <EditEmployee id="offcanvas_edit" />
            <AddEmployee id="offcanvas_add" /> */}
            {/* <CreateQuoteForm SentQuoteList={SentQuoteList} id="offcanvas_create" />
            <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
        </>

    )
}

export default GeneralJobs